module.exports = __webpack_public_path__ + "media/Cumprimentos.10f91935.mp3";